(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7678,7187,9801],{

/***/ 70163:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdministrationGroupLine"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Line"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":101}}');
    doc.loc.source = JSON.parse('{"body":"fragment AdministrationGroupLine on Line {\\n  id\\n  name\\n  description\\n  nodes {\\n    id\\n    type\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 80147:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdministrationGroupPeripheral"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Peripheral"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":116}}');
    doc.loc.source = JSON.parse('{"body":"fragment AdministrationGroupPeripheral on Peripheral {\\n  _id\\n  peripheralId\\n  peripheralType\\n  name\\n  description\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 54101:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdministrationGroupRole"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Role"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":64}}');
    doc.loc.source = JSON.parse('{"body":"fragment AdministrationGroupRole on Role {\\n  id\\n  name\\n  type\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 88823:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdministrationGroupSimple"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"defaultGroup"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nodeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupRole"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"peripherals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupPeripheral"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupLine"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sub"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":494}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/administration/group-line.gql\'\\n#import \'@/graphql/fragments/administration/group-peripheral.gql\'\\n#import \'@/graphql/fragments/administration/group-role.gql\'\\n\\nfragment AdministrationGroupSimple on Group {\\n  id\\n  defaultGroup\\n  name\\n  description\\n  nodeId\\n  owner {\\n    id\\n  }\\n  role {\\n    ...AdministrationGroupRole\\n  }\\n  peripherals {\\n    ...AdministrationGroupPeripheral\\n  }\\n  lines {\\n    ...AdministrationGroupLine\\n  }\\n  users {\\n    items {\\n      sub\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(70163).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(80147).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(54101).definitions)));


      module.exports = doc;
    


/***/ }),

/***/ 51725:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AdministrationMe"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sub"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":76}}');
    doc.loc.source = JSON.parse('{"body":"fragment AdministrationMe on User {\\n  sub\\n  company {\\n    id\\n    name\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 67394:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Batch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Batch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manualScrap"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plannedStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStart"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actualStop"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":144}}');
    doc.loc.source = JSON.parse('{"body":"fragment Batch on Batch {\\n  batchId\\n  batchNumber\\n  state\\n  amount\\n  manualScrap\\n  plannedStart\\n  actualStart\\n  actualStop\\n  comment\\n  lineId\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 96352:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Packaging"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Packaging"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"packagingId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagingNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":101}}');
    doc.loc.source = JSON.parse('{"body":"fragment Packaging on Packaging {\\n  packagingId\\n  lineId\\n  name\\n  packagingNumber\\n  unit\\n  comment\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 50619:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Product"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lineId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"validatedLineSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectedAverageSpeed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataMultiplier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parameters"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":181}}');
    doc.loc.source = JSON.parse('{"body":"fragment Product on Product {\\n  productId\\n  name\\n  itemNumber\\n  lineId\\n  validatedLineSpeed\\n  expectedAverageSpeed\\n  dataMultiplier\\n  comment\\n  parameters {\\n    key\\n    value\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 89867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"administrationDetailedGroups"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationMe"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groups"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"detailedGroups","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupSimple"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripherals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupPeripheral"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AdministrationGroupLine"},"directives":[]}]}}]}}],"loc":{"start":0,"end":684}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/administration/me.gql\'\\n#import \'@/graphql/fragments/administration/group-simple.gql\'\\n#import \'@/graphql/fragments/administration/group-line.gql\'\\n#import \'@/graphql/fragments/administration/group-peripheral.gql\'\\n\\nquery administrationDetailedGroups {\\n  user {\\n    ...AdministrationMe\\n  }\\n  company {\\n    id\\n    groups @connection(key: \\"detailedGroups\\") {\\n      ...AdministrationGroupSimple\\n    }\\n    roles {\\n      id\\n      name\\n      type\\n      permissions {\\n        key\\n        type\\n        description\\n      }\\n    }\\n  }\\n\\n  devices {\\n    _id\\n    peripherals {\\n      ...AdministrationGroupPeripheral\\n    }\\n  }\\n  lines {\\n    ...AdministrationGroupLine\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(51725).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(88823).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(70163).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(80147).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.administrationDetailedGroups = oneQuery(doc, "administrationDetailedGroups");
        


/***/ }),

/***/ 51844:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deviceMinimumData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Time"}}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"points"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheral"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peripheralInformation"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"StringValue","value":"lineOverviewWithKPI","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"samples"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"points"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"to"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"batches"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nextToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Batch"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"produced"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Product"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packaging"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Packaging"},"directives":[]}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineStatus"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cause"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfigEnums"},"directives":[]}]}}],"loc":{"start":0,"end":1679}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n#import \'@/graphql/fragments/sensor-config-enums.gql\'\\n#import \'@/graphql/fragments/batch.gql\'\\n#import \'@/graphql/fragments/product.gql\'\\n#import \'@/graphql/fragments/packaging.gql\'\\n\\nquery deviceMinimumData($uuid: ID!, $index: ID!, $time: [Time!]!, $points: Int!) {\\n  device(uuid: $uuid) {\\n    _id\\n    owner\\n    peripheral(index: $index) {\\n      _id\\n      id\\n      peripheralId\\n      index\\n      name\\n      peripheralType\\n      description\\n      ... on Sensor {\\n        peripheralInformation {\\n          node {\\n            type\\n          }\\n          line {\\n            id\\n            name\\n          }\\n        }\\n        config {\\n          ...SensorConfig\\n        }\\n        time(time: $time) @connection(key: \\"lineOverviewWithKPI\\") {\\n          timeRange {\\n            from\\n            to\\n          }\\n          samples(points: $points) {\\n            data {\\n              count\\n              accValue\\n              minValue\\n              maxValue\\n            }\\n            timeRange {\\n              from\\n              to\\n            }\\n          }\\n          batches {\\n            nextToken\\n            items {\\n              ...Batch\\n              stats {\\n                data {\\n                  produced\\n                }\\n              }\\n              product {\\n                ...Product\\n                packaging {\\n                  ...Packaging\\n                }\\n              }\\n            }\\n          }\\n          stats {\\n            data {\\n              lineStatus {\\n                status\\n                duration\\n                cause\\n              }\\n            }\\n          }\\n        }\\n      }\\n    }\\n  }\\n  ...SensorConfigEnums\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(79696).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(67394).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(50619).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(96352).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceMinimumData = oneQuery(doc, "deviceMinimumData");
        


/***/ }),

/***/ 98246:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deviceNetworkStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"device"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"network"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"connection"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":162}}');
    doc.loc.source = JSON.parse('{"body":"# Used for the status icon for a given device\\nquery deviceNetworkStatus($uuid: ID!) {\\n  device(uuid: $uuid) {\\n    network {\\n      connection\\n    }\\n    type\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.deviceNetworkStatus = oneQuery(doc, "deviceNetworkStatus");
        


/***/ }),

/***/ 36117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 40636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sensors",
      function () {
        return __webpack_require__(57191);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ overview_top_bar; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(26806);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(90926);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(77797);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(36762);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(84074);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(98242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+base@5.0.0-beta.4_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/base/NoSsr/NoSsr.js
var NoSsr = __webpack_require__(91217);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(51804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(30810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+system@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react@17.0.2/node_modules/@mui/system/esm/colorManipulator.js
var colorManipulator = __webpack_require__(50082);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-select@5.7.3_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/react-select/creatable/dist/react-select-creatable.esm.js + 19 modules
var react_select_creatable_esm = __webpack_require__(54799);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(21586);
;// CONCATENATED MODULE: ./components/bars/search-bar.tsx


























var styles = function(theme) {
    return {
        root: {
            flex: 1
        },
        input: {
            display: "flex",
            padding: 0,
            height: theme.spacing(5)
        },
        valueContainer: {
            display: "flex",
            flexWrap: "wrap",
            flex: 1,
            alignItems: "center",
            overflow: "hidden"
        },
        chip: {
            margin: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(0.25))
        },
        chipFocused: {
            backgroundColor: (0,colorManipulator/* emphasize */._4)(theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
        },
        noOptionsMessage: {
            padding: "".concat(theme.spacing(), "px ").concat(theme.spacing(2))
        },
        singleValue: {
            fontSize: 16
        },
        placeholder: {
            position: "absolute",
            left: 2,
            fontSize: 16
        },
        paper: {
            position: "absolute",
            zIndex: 1,
            marginTop: theme.spacing(),
            left: 0,
            right: 0
        },
        divider: {
            height: theme.spacing(2)
        }
    };
};
function NoOptionsMessage(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.noOptionsMessage
    }, props.innerProps), {
        children: props.children
    }));
}
function inputComponent(_param) {
    var inputRef = _param.inputRef, props = (0,_object_without_properties/* default */.Z)(_param, [
        "inputRef"
    ]);
    // NOTE: Order is important, InputBase sets ref to null, thus we ensure it's
    // value by setting ref after the spread.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: inputRef
    }));
}
function Control(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        variant: "filled",
        fullWidth: true,
        InputProps: {
            inputComponent: inputComponent,
            inputProps: (0,_object_spread/* default */.Z)({
                className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.input,
                inputRef: props.innerRef,
                children: props.children
            }, props.innerProps)
        }
    }, props.selectProps.textFieldProps));
}
function Option(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            display: "flex",
            minWidth: 0,
            padding: "5px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: props.innerRef,
            selected: props.isFocused,
            component: "div",
            sx: {
                fontWeight: props.isSelected ? 500 : 400,
                width: "100%"
            }
        }, props.innerProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    flex: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                },
                children: [
                    " ",
                    props.children,
                    " "
                ]
            })
        }))
    });
}
function Placeholder(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: "textSecondary",
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.placeholder
    }, props.innerProps), {
        children: props.children
    }));
}
function SingleValue(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.singleValue
    }, props.innerProps), {
        children: props.children
    }));
}
function ValueContainer(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.valueContainer,
        children: props.children
    });
}
function MultiValue(props) {
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
        tabIndex: -1,
        label: props.children,
        className: (0,clsx_m["default"])((ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.chip, (0,_define_property/* default */.Z)({}, (ref1 = props.selectProps.classes) === null || ref1 === void 0 ? void 0 : ref1.chipFocused, props.isFocused)),
        onDelete: props.removeProps.onClick,
        deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, (0,_object_spread/* default */.Z)({}, props.removeProps))
    });
}
function Menu(props) {
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        square: true,
        className: (ref = props.selectProps.classes) === null || ref === void 0 ? void 0 : ref.paper
    }, props.innerProps), {
        children: props.children
    }));
}
var components = {
    Control: Control,
    Menu: Menu,
    MultiValue: MultiValue,
    NoOptionsMessage: NoOptionsMessage,
    Option: Option,
    Placeholder: Placeholder,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
};
var createOption = function(label) {
    return {
        label: label,
        value: {
            type: "string",
            value: label
        }
    };
};
var SearchBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SearchBar, _Component);
    var _super = (0,_create_super/* default */.Z)(SearchBar);
    function SearchBar() {
        (0,_class_call_check/* default */.Z)(this, SearchBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            inputValue: ""
        };
        _this.formatLabel = function(val) {
            return "".concat(_this.props.t([
                "shared:searchFor"
            ], {
                defaultValue: "Search for"
            }), ' "').concat(val, '"');
        };
        _this.createOption = function(inputValue) {
            return _this.props.handleChange((0,_to_consumable_array/* default */.Z)(_this.props.value).concat([
                createOption(inputValue)
            ]));
        };
        _this.handleChange = function(val) {
            _this.props.handleChange(Array.isArray(val) ? val : val ? [
                val
            ] : []);
        };
        return _this;
    }
    var _proto = SearchBar.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, value = _props.value, theme = _props.theme, suggestions = _props.suggestions, t = _props.t;
        var selectStyles = {
            input: function(base) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, base), {
                    color: theme.palette.text.primary,
                    "& input": {
                        font: "inherit"
                    }
                });
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSsr/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                sx: {
                                    marginRight: theme.spacing(),
                                    backgroundColor: theme.palette.primary.main
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            sx: {
                                flexGrow: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_creatable_esm/* default */.Z, {
                                // @ts-ignore
                                classes: classes,
                                styles: selectStyles,
                                textFieldProps: {
                                    InputLabelProps: {
                                        shrink: true
                                    }
                                },
                                createOptionPosition: "first",
                                formatCreateLabel: this.formatLabel,
                                options: suggestions,
                                components: components,
                                value: value,
                                onCreateOption: this.createOption,
                                onChange: this.handleChange,
                                placeholder: "".concat(t([
                                    "shared:typeToSearch"
                                ], {
                                    defaultValue: "Type to search"
                                }), "..."),
                                isMulti: true,
                                isClearable: true
                            })
                        })
                    ]
                })
            })
        });
    };
    return SearchBar;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var search_bar = (enhance(SearchBar));

// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(82059);
;// CONCATENATED MODULE: ./components/bars/overview-top-bar.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            overflow: "visible",
            marginBottom: theme.spacing(),
            "@media print": {
                display: "none"
            }
        },
        content: {
            paddingBottom: theme.spacing(2)
        },
        divContainer: {
            display: "flex",
            width: "100%",
            flexWrap: "nowrap"
        },
        hideOnSMDown: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        hideOnMDup: (0,_define_property/* default */.Z)({
            display: "flex"
        }, theme.breakpoints.up("md"), {
            display: "none"
        })
    };
});
var OverviewTopBar = function(param) {
    var suggestions = param.suggestions, search = param.search, children = param.children, totalCount = param.totalCount, page = param.page, pageSize = param.pageSize, handleSearchChange = param.handleSearchChange, handlePageChange = param.handlePageChange;
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        elevation: 1,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
            className: classes.content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.divContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar, {
                            suggestions: suggestions,
                            value: search,
                            handleChange: handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.hideOnSMDown,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                }),
                                children
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classes.hideOnMDup,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        justifyContent: "space-between",
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                    fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                        totalPages: Math.ceil(totalCount / pageSize),
                                        currentPage: page,
                                        onCurrentPageChange: handlePageChange,
                                        totalCount: totalCount,
                                        pageSize: pageSize
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                children: children
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var overview_top_bar = (OverviewTopBar);


/***/ }),

/***/ 56487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MutationButton; },
/* harmony export */   "t": function() { return /* binding */ MutationIconButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53563);
/* harmony import */ var _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70747);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49692);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60945);
/* harmony import */ var _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51848);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);












var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        buttonMutationLoading: {
            marginRight: theme.spacing(1),
            marginTop: "-2px"
        },
        buttonMutationWithIconLoading: {
            position: "absolute",
            left: "5px"
        },
        iconButtonMutationLoading: {
            marginTop: theme.spacing(0.5),
            marginLeft: "auto",
            marginRight: "auto",
            position: "absolute",
            left: "0",
            right: "0"
        },
        addCustomColor: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        addIconCustomColor: {
            color: theme.palette.error.main
        }
    };
});
var MutationButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, withIcon = _param.withIcon, variant = _param.variant, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, muiVariant = _param.muiVariant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "withIcon",
        "variant",
        "overrideProgressStyle",
        "isRed",
        "color",
        "muiVariant"
    ]);
    var classes = useStyles().classes;
    var ButtonComponent = variant === "fab" ? _mui_material_Fab__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z : variant === "icon" ? _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, rest), {
                color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary",
                disabled: disabled || loading,
                onClick: function(e) {
                    return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                },
                variant: muiVariant,
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        size: withIcon ? 32 : 18,
                        className: "".concat(classes.buttonMutationLoading, " ").concat(withIcon ? classes.buttonMutationWithIconLoading : ""),
                        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                        }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                    }),
                    children
                ]
            }))
        })
    });
};
/**
 * Quickly set up an `IconButton` wrapped in a `Tooltip` for displaying a message when it's disabled.
 *
 * If a disabled prop has been passed, this will also make sure to block any onClick action, while
 * it is disabled.
 *
 * If a loading prop is passed in, it will automatically handle adding and removing loading spinner
 * around the icon.
 */ var MutationIconButton = function(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _tooltipPlacement = _param.tooltipPlacement, tooltipPlacement = _tooltipPlacement === void 0 ? "top" : _tooltipPlacement, _tooltipMsg = _param.tooltipMsg, tooltipMsg = _tooltipMsg === void 0 ? "" : _tooltipMsg, _tooltipMsgDisabled = _param.tooltipMsgDisabled, tooltipMsgDisabled = _tooltipMsgDisabled === void 0 ? "" : _tooltipMsgDisabled, spanClass = _param.spanClass, loading = _param.loading, onClick = _param.onClick, loadingColor = _param.loadingColor, overrideProgressStyle = _param.overrideProgressStyle, isRed = _param.isRed, color = _param.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "disabled",
        "tooltipPlacement",
        "tooltipMsg",
        "tooltipMsgDisabled",
        "spanClass",
        "loading",
        "onClick",
        "loadingColor",
        "overrideProgressStyle",
        "isRed",
        "color"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        placement: tooltipPlacement,
        title: disabled ? tooltipMsgDisabled : tooltipMsg,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "".concat(isRed ? classes.addIconCustomColor : "", " ").concat(spanClass),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    color: color !== null && color !== void 0 ? color : isRed ? "inherit" : "primary"
                }, rest), {
                    disabled: disabled || loading,
                    onClick: function(e) {
                        return !disabled && (onClick === null || onClick === void 0 ? void 0 : onClick(e));
                    },
                    size: "large",
                    children: children
                })),
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    size: 40,
                    className: classes.iconButtonMutationLoading,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        color: loadingColor !== null && loadingColor !== void 0 ? loadingColor : _mui_material_colors__WEBPACK_IMPORTED_MODULE_11__/* ["default"][500] */ .Z[500]
                    }, overrideProgressStyle !== null && overrideProgressStyle !== void 0 ? overrideProgressStyle : {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 13258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36712);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97591);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53189);
/* harmony import */ var mdi_material_ui_Check__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85403);
/* harmony import */ var mdi_material_ui_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94479);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _components_dialogs_dialog_header__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37668);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21586);
/* harmony import */ var _hocs_with_width__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46242);
















var styles = function(theme) {
    return {
        topPadding: {
            paddingTop: theme.spacing(3)
        },
        titlebar: {
            backgroundColor: "#f7f7f7"
        },
        actions: {
            justifyContent: "right"
        }
    };
};
var ConfirmDialog = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ConfirmDialog, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ConfirmDialog);
    function ConfirmDialog() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ConfirmDialog);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {};
        return _this;
    }
    var _proto = ConfirmDialog.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, fullScreen = _props.fullScreen, onClose = _props.onClose, onConfirm = _props.onConfirm, open = _props.open, t = _props.t, theme = _props.theme, width = _props.width, requestedActions = _props.actions;
        var title = this.props.title || "";
        var content = this.props.content || "";
        var actions = requestedActions ? function() {
            return requestedActions;
        } : function() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        color: "primary",
                        onClick: onClose,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mdi_material_ui_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                style: {
                                    marginRight: theme.spacing(),
                                    marginTop: "-3px"
                                }
                            }),
                            (0,_hocs_with_width__WEBPACK_IMPORTED_MODULE_8__/* .isWidthUp */ .yJ)("md", width) ? t([
                                "shared:close"
                            ], {
                                defaultValue: "Close"
                            }) : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        color: "primary",
                        onClick: onConfirm,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(mdi_material_ui_Check__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                style: {
                                    marginRight: theme.spacing(),
                                    marginTop: "-3px"
                                }
                            }),
                            (0,_hocs_with_width__WEBPACK_IMPORTED_MODULE_8__/* .isWidthUp */ .yJ)("md", width) ? t([
                                "shared:confirm"
                            ], {
                                defaultValue: "Confirm"
                            }) : ""
                        ]
                    })
                ]
            });
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            fullScreen: fullScreen,
            open: open,
            onClose: onClose,
            fullWidth: true,
            maxWidth: "sm",
            scroll: "body",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_dialogs_dialog_header__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    title: title,
                    onClose: onClose
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    className: classes.topPadding,
                    children: content
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    className: classes.actions,
                    children: actions()
                })
            ]
        });
    };
    return ConfirmDialog;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_width__WEBPACK_IMPORTED_MODULE_8__/* .withWidth */ .of)(), (0,react_i18next__WEBPACK_IMPORTED_MODULE_14__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_15__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(ConfirmDialog));


/***/ }),

/***/ 37668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(426);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49692);
/* harmony import */ var _mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53486);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71601);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_1__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: "flex",
            alignItems: "center",
            padding: theme.spacing(2),
            backgroundColor: "#f7f7f7"
        },
        /* Styles applied to the action element. */ action: {
            flex: "0 0 auto",
            alignSelf: "center"
        },
        /* Styles applied to the content wrapper element. */ content: {
            flex: "1 1 auto"
        }
    };
});
var DialogHeader = function(_param) {
    var action = _param.action, title = _param.title, onClose = _param.onClose, _children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "action",
        "title",
        "onClose",
        "children"
    ]);
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: classes.content
            }, props), {
                children: title
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.action,
                children: [
                    action,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        id: "closeDialog",
                        onClick: onClose,
                        size: "large",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            fontSize: "small"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DialogHeader);


/***/ }),

/***/ 35715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36712);
/* harmony import */ var _mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97591);
/* harmony import */ var _mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53189);
/* harmony import */ var _mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2701);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);












var DiscardChangesDialog = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(DiscardChangesDialog, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DiscardChangesDialog);
    function DiscardChangesDialog() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, DiscardChangesDialog);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onDiscard = function() {
            return _this.props.handleResponse(true);
        };
        _this.onSave = function() {
            return _this.props.handleResponse(false);
        };
        return _this;
    }
    var _proto = DiscardChangesDialog.prototype;
    _proto.render = function render() {
        var _props = this.props, t = _props.t, open = _props.open;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                open: open,
                onClose: this.onDiscard,
                "aria-labelledby": "alert-dialog-title",
                "aria-describedby": "alert-dialog-description",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_DialogContentText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "alert-dialog-description",
                            children: t([
                                "shared:discardMessage"
                            ], {
                                defaultValue: "You have unsaved changes. Are you sure you want to close?"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_DialogActions__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                onClick: this.onDiscard,
                                color: "primary",
                                children: t([
                                    "shared:discard"
                                ], {
                                    defaultValue: "Discard"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                onClick: this.onSave,
                                color: "primary",
                                autoFocus: true,
                                children: t([
                                    "shared:save"
                                ], {
                                    defaultValue: "Save"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return DiscardChangesDialog;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .withTranslation */ .Z)([
    "shared"
]));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(DiscardChangesDialog));


/***/ }),

/***/ 81009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nv": function() { return /* binding */ getNodeIcon; }
/* harmony export */ });
/* unused harmony exports CAMERA_ICON, EVENT_ICON, getNodeRingIconPath */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89178);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97887);






var CAMERA_ICON = (/* unused pure expression or super */ null && (Cctv));
var EVENT_ICON = (/* unused pure expression or super */ null && (VideoInputAntenna));
var getNodeIcon = function(className, type) {
    switch(type){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Main */ .Jq.Main:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/bottleneck.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Counter */ .Jq.Counter:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/counter.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Scrap */ .Jq.Scrap:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/scrap.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Camera */ .Jq.Camera:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/camera.svg",
                className: className
            });
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_2__/* .NodeType.Event */ .Jq.Event:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/event.svg",
                className: className
            });
        default:
            _types__WEBPACK_IMPORTED_MODULE_3__/* .assertUnreachable */ .U(type);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/counter.svg",
                className: className
            });
    }
};
var getNodeRingIconPath = function(type) {
    var highlighted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ICON_PATH = "/images/";
    switch(type){
        case Schema.NodeType.Main:
            return highlighted ? "".concat(ICON_PATH, "bottleneck_ring_highlight.svg") : "".concat(ICON_PATH, "bottleneck_ring.svg");
        case Schema.NodeType.Counter:
            return highlighted ? "".concat(ICON_PATH, "counter_ring_highlight.svg") : "".concat(ICON_PATH, "counter_ring.svg");
        case Schema.NodeType.Scrap:
            return highlighted ? "".concat(ICON_PATH, "scrap_ring_highlight.svg") : "".concat(ICON_PATH, "scrap_ring.svg");
        case Schema.NodeType.Camera:
            return highlighted ? "".concat(ICON_PATH, "camera_ring_highlight.svg") : "".concat(ICON_PATH, "camera_ring.svg");
        case Schema.NodeType.Event:
            return highlighted ? "".concat(ICON_PATH, "event_ring_highlight.svg") : "".concat(ICON_PATH, "event_ring.svg");
        default:
            Types.assertUnreachable(type);
            return highlighted ? "".concat(ICON_PATH, "counter_ring_highlight.svg") : "".concat(ICON_PATH, "counter_ring.svg");
    }
};


/***/ }),

/***/ 72958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ DeviceSignalAvatar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62523);
/* harmony import */ var _mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5439);
/* harmony import */ var _mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(585);
/* harmony import */ var _mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(49612);
/* harmony import */ var _mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76853);
/* harmony import */ var _mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59988);
/* harmony import */ var _mui_material_Avatar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36762);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60945);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(14517);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89178);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71601);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98246);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_graphql_queries__WEBPACK_IMPORTED_MODULE_15__);
















var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        avatarWhite: {
            backgroundColor: "#fff"
        },
        iconBlack: {
            color: theme.palette.primary.main
        }
    };
});
/** A component to display the connectivity of a device */ var DeviceSignalAvatar = function(param) {
    var isUnclaimed = param.isUnclaimed, online = param.online, wifiEnabled = param.wifiEnabled, type = param.type;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(), 2), t = ref[0], i18n = ref[1];
    var classes = useStyles().classes;
    var _NetworkConnectionType = generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__/* .NetworkConnectionType */ .u2, WIFI = _NetworkConnectionType.WIFI, CELLULAR = _NetworkConnectionType.CELLULAR;
    var actualType = type !== null && type !== void 0 ? type : wifiEnabled ? WIFI : CELLULAR;
    var helperText = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (isUnclaimed) {
            return t("shared:deviceArchived", {
                defaultValue: "Device archived"
            });
        }
        if (online === false) {
            return t("device:offline", {
                defaultValue: "This device is offline"
            });
        }
        if (actualType === WIFI) {
            return t("device:wifiConnected", {
                defaultValue: "WiFi connected"
            });
        } else {
            return t("shared:cellularConnected", {
                defaultValue: "Cellular connected"
            });
        }
    }, [
        i18n.language,
        isUnclaimed,
        online,
        actualType
    ]);
    var icon;
    if (isUnclaimed) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_DoNotDisturb__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
    } else if (actualType === WIFI) {
        if (online) {
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi4Bar__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
        } else {
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalWifi0Bar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
        }
    } else {
        if (online) {
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular4Bar__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {});
        } else {
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_SignalCellular0Bar__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {});
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        title: helperText,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Avatar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__["default"])(classes.avatarWhite, classes.iconBlack, "hideInPercy"),
            children: icon
        })
    });
};
/** A component displaying the signal for a sensor (does an interal query for now until fallback is implemented) */ var SignalAvatar = function(param) {
    var isUnclaimed = param.isUnclaimed, uuid = param.uuid, online = param.online;
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_14__.useLazyQuery)((_graphql_queries__WEBPACK_IMPORTED_MODULE_15___default())), 2), update = ref2[0], ref3 = ref2[1], data = ref3.data, loading = ref3.loading;
    var ref4;
    var type = (ref4 = data === null || data === void 0 ? void 0 : (ref = data.device) === null || ref === void 0 ? void 0 : (ref1 = ref.network) === null || ref1 === void 0 ? void 0 : ref1.connection) !== null && ref4 !== void 0 ? ref4 : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__/* .NetworkConnectionType.WIFI */ .u2.WIFI;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (uuid) {
            update({
                variables: {
                    uuid: uuid
                }
            });
        }
    }, [
        uuid
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeviceSignalAvatar, {
        online: online,
        isUnclaimed: isUnclaimed,
        type: type
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignalAvatar);


/***/ }),

/***/ 82059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81666);
/* harmony import */ var _mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1893);
/* harmony import */ var _mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94298);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27908);
/* harmony import */ var _mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49692);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21586);


















var styles = function(theme) {
    var _obj;
    return {
        pagination: {
            alignItems: "center",
            marginLeft: "1em",
            display: "flex"
        },
        buttons: {
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center"
        },
        rowsLabel: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            whiteSpace: "nowrap"
        }, theme.typography.caption), (_obj = {
            paddingRight: theme.spacing(5)
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
            paddingRight: "0"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, "lineHeight", theme.spacing(5)), _obj)),
        button: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            color: "inherit",
            minWidth: theme.spacing(2),
            height: theme.spacing(5)
        }, theme.breakpoints.down("md"), {
            display: "none"
        }),
        activeButton: {
            fontWeight: "bold",
            cursor: "default"
        },
        arrowButton: {
            transform: theme.direction === "rtl" ? "rotate(180deg)" : undefined
        }
    };
};
var PageButton = function(args) {
    var text = args.text, isActive = args.isActive, isDisabled = args.isDisabled, classes = args.classes, onClick = args.onClick;
    var _obj;
    var buttonClasses = (0,clsx__WEBPACK_IMPORTED_MODULE_7__["default"])((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.button, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, classes.activeButton, isActive), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: buttonClasses,
        disabled: isDisabled,
        onClick: onClick,
        disableRipple: isActive,
        children: text
    });
};
var ellipsisSymbol = "…";
var Paginator = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Paginator, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(Paginator);
    function Paginator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, Paginator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.setPage = function(desiredPage) {
            return function() {
                return _this.props.onCurrentPageChange(desiredPage);
            };
        };
        _this.renderPageButtons = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, classes = _props.classes;
            var pageButtons = [];
            var maxButtonCount = 3;
            var startPage = 1;
            var endPage = totalPages || 1;
            if (maxButtonCount < totalPages) {
                startPage = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .calculateStartPage */ .kw6)(currentPage + 1, maxButtonCount, totalPages);
                endPage = startPage + maxButtonCount - 1;
            }
            if (startPage > 1) {
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(1),
                    classes: classes,
                    onClick: _this.setPage(0)
                }, 1));
                if (startPage > 2) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisStart"));
                }
            }
            for(var page = startPage; page <= endPage; page += 1){
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(page),
                    isActive: page === currentPage + 1,
                    classes: classes,
                    onClick: _this.setPage(page - 1),
                    isDisabled: startPage === endPage
                }, page));
            }
            if (endPage < totalPages) {
                if (endPage < totalPages - 1) {
                    pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                        text: ellipsisSymbol,
                        classes: classes,
                        isDisabled: true
                    }, "ellipsisEnd"));
                }
                pageButtons.push(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageButton, {
                    text: String(totalPages),
                    classes: classes,
                    onClick: _this.setPage(totalPages - 1)
                }, totalPages));
            }
            return pageButtons;
        };
        _this.previousPage = function() {
            var _props = _this.props, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage > 0 && onCurrentPageChange(currentPage - 1);
        };
        _this.nextPage = function() {
            var _props = _this.props, totalPages = _props.totalPages, currentPage = _props.currentPage, onCurrentPageChange = _props.onCurrentPageChange;
            return currentPage < totalPages - 1 && onCurrentPageChange(currentPage + 1);
        };
        return _this;
    }
    var _proto = Paginator.prototype;
    _proto.render = function render() {
        var _props = this.props, totalPages = _props.totalPages, totalCount = _props.totalCount, pageSize = _props.pageSize, currentPage = _props.currentPage, classes = _props.classes, t = _props.t;
        var from = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .firstRowOnPage */ .dF$)(currentPage, pageSize, totalCount);
        var to = (0,_devexpress_dx_grid_core__WEBPACK_IMPORTED_MODULE_1__/* .lastRowOnPage */ .ZN$)(currentPage, pageSize, totalCount);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes.pagination,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classes.rowsLabel,
                    children: "".concat(from).concat(from < to ? "-".concat(to) : "", " ").concat(t([
                        "shared:pageOf"
                    ], {
                        defaultValue: "of"
                    }), " ").concat(totalCount)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === 0,
                            onClick: this.previousPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronLeft__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
                        }),
                        this.renderPageButtons(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_IconButton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            className: classes.arrowButton,
                            disabled: currentPage === totalPages - 1 || totalCount === 0,
                            onClick: this.nextPage,
                            size: "large",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ChevronRight__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                        })
                    ]
                })
            ]
        });
    };
    return Paginator;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_16__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles, {
    name: "Paginator"
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(Paginator));


/***/ }),

/***/ 38057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ SelectValidator; },
/* harmony export */   "BV": function() { return /* binding */ MultiSelectWithSearchValidator; },
/* harmony export */   "nn": function() { return /* binding */ SelectWithSearchValidator; }
/* harmony export */ });
/* unused harmony export WrapValidator */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48417);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_FilledInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8671);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39829);
/* harmony import */ var _mui_material_FormHelperText__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1679);
/* harmony import */ var _mui_material_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28640);
/* harmony import */ var _mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(66909);
/* harmony import */ var _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32060);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30810);
/* harmony import */ var _mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(41791);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8081);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21586);
/* eslint-disable max-classes-per-file */ 




















var inputVariantComponent = {
    standard: _mui_material_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
    filled: _mui_material_FilledInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
    outlined: _mui_material_OutlinedInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
};
var styles = function() {
    return {
        star: {
            "&:after": {
                content: "' *'"
            }
        }
    };
};
// tslint:disable:max-classes-per-file
var InputValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(InputValidator, ValidatorComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(InputValidator);
    function InputValidator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, InputValidator);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isValid: true
        };
        return _this;
    }
    var _proto = InputValidator.prototype;
    _proto.render = function render() {
        var _props = this.props, errorMessages = _props.errorMessages, _validators = _props.validators, validators = _validators === void 0 ? [] : _validators, containerClass = _props.containerClass, requiredError = _props.requiredError, helperText = _props.helperText, inputLabelProps = _props.inputLabelProps, label = _props.label, validatorListener = _props.validatorListener, onKeyPress = _props.onKeyPress, variant = _props.variant, propLabelWidth = _props.labelWidth, classes = _props.classes, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
            "errorMessages",
            "validators",
            "containerClass",
            "requiredError",
            "helperText",
            "inputLabelProps",
            "label",
            "validatorListener",
            "onKeyPress",
            "variant",
            "labelWidth",
            "classes"
        ]);
        var labelWidth = propLabelWidth;
        var isValid = this.state.isValid;
        // Unless overridden, we disable enter key in the input.
        var defaultKeyPress = function(ev) {
            if (ev.key === "Enter") {
                ev.preventDefault();
            }
        };
        var useOnKeyPress = defaultKeyPress;
        if (onKeyPress) {
            useOnKeyPress = onKeyPress;
        }
        var InputVariantComponent = inputVariantComponent.standard;
        var FilledInputVariantComponent = inputVariantComponent.filled;
        var OutlinedInputComponent = inputVariantComponent.outlined;
        if (variant === "outlined" && !labelWidth) {
            labelWidth = 60;
        }
        var ref;
        rest.required = (ref = rest === null || rest === void 0 ? void 0 : rest.required) !== null && ref !== void 0 ? ref : validators === null || validators === void 0 ? void 0 : validators.includes("required");
        var starAtEnd = (validators === null || validators === void 0 ? void 0 : validators.includes("required")) ? classes.star : "";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "filled",
            fullWidth: true,
            className: containerClass,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_InputLabel__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, inputLabelProps), {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__["default"])(inputLabelProps === null || inputLabelProps === void 0 ? void 0 : inputLabelProps.className, starAtEnd),
                    children: label
                })),
                variant === undefined || variant === "filled" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FilledInputVariantComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })) : variant === "outlined" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(OutlinedInputComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputVariantComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                    error: !isValid,
                    onKeyPress: useOnKeyPress
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormHelperText__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    id: "weight-helper-text",
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return InputValidator;
}(react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__/* .ValidatorComponent */ .nE);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_17__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["ZP"] = (enhance(InputValidator));
var SelectValidator = /*#__PURE__*/ function(ValidatorComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SelectValidator, ValidatorComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(SelectValidator);
    function SelectValidator() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, SelectValidator);
        return _super.apply(this, arguments);
    }
    var _proto = SelectValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass"
        ]);
        var isValid = this.state.isValid;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            variant: "filled",
            fullWidth: true,
            className: containerClass,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, rest), {
                select: true,
                error: !isValid || error,
                helperText: !isValid && this.getErrorMessage() || helperText
            }))
        });
    };
    return SelectValidator;
}(react_form_validator_core__WEBPACK_IMPORTED_MODULE_2__/* .ValidatorComponent */ .nE);
/**
 * Wrap form components in a validator component, that will display the error text, and set a
 * passed in `validClass`/`invalidClass`.
 */ var WrapValidator = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ValidatorComponent) {
    "use strict";
    _inherits(WrapValidator, ValidatorComponent);
    var _super = _create_super(WrapValidator);
    function WrapValidator() {
        _class_call_check(this, WrapValidator);
        return _super.apply(this, arguments);
    }
    var _proto = WrapValidator.prototype;
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _props = this.props, error = _props.error, errorMessages = _props.errorMessages, validators = _props.validators, requiredError = _props.requiredError, helperText = _props.helperText, validatorListener = _props.validatorListener, withRequiredValidator = _props.withRequiredValidator, containerClass = _props.containerClass, children = _props.children, invalidClass = _props.invalidClass, validClass = _props.validClass, rest = _object_without_properties(_props, [
            "error",
            "errorMessages",
            "validators",
            "requiredError",
            "helperText",
            "validatorListener",
            "withRequiredValidator",
            "containerClass",
            "children",
            "invalidClass",
            "validClass"
        ]);
        var isValid = this.state.isValid;
        var formContainerClass = "".concat(containerClass, " ").concat(isValid ? validClass ? validClass : "" : invalidClass ? invalidClass : "");
        return /*#__PURE__*/ _jsxs(FormControl, {
            variant: "filled",
            fullWidth: true,
            className: formContainerClass,
            children: [
                children,
                /*#__PURE__*/ _jsx(FormHelperText, {
                    id: "weight-helper-text",
                    error: !isValid,
                    children: !isValid && this.getErrorMessage() || helperText
                })
            ]
        });
    };
    return WrapValidator;
}(ValidatorComponent)));
var SelectWithSearchValidator = function(_param) {
    var error = _param.error, errorMessages = _param.errorMessages, helperText = _param.helperText, containerClass = _param.containerClass, optionsArray = _param.optionsArray, onChangeProp = _param.onChangeProp, getOptionSelected = _param.getOptionSelected, filterOptions = _param.filterOptions, selectedValue = _param.selectedValue, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "error",
        "errorMessages",
        "helperText",
        "containerClass",
        "optionsArray",
        "onChangeProp",
        "getOptionSelected",
        "filterOptions",
        "selectedValue"
    ]);
    var sortedOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(optionsArray).sort(function(a, b) {
            var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                //sort string ascending
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }, [
        optionsArray
    ]);
    var handleChange = function(event, value) {
        if (!value) {
            return;
        }
        onChangeProp(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "filled",
        fullWidth: true,
        className: containerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            id: "search-box",
            options: sortedOptions,
            filterOptions: filterOptions,
            getOptionLabel: function(option) {
                return option.name || "";
            },
            onChange: handleChange,
            isOptionEqualToValue: getOptionSelected,
            defaultValue: selectedValue,
            renderInput: function(params) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, params, rest), {
                    error: error,
                    helperText: errorMessages || helperText
                }));
            }
        })
    });
};
var MultiSelectWithSearchValidator = function(_param) {
    var error = _param.error, errorMessages = _param.errorMessages, validators = _param.validators, requiredError = _param.requiredError, helperText = _param.helperText, validatorListener = _param.validatorListener, withRequiredValidator = _param.withRequiredValidator, containerClass = _param.containerClass, optionsArray = _param.optionsArray, onChangeProp = _param.onChangeProp, selectedValue = _param.selectedValue, _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
        "error",
        "errorMessages",
        "validators",
        "requiredError",
        "helperText",
        "validatorListener",
        "withRequiredValidator",
        "containerClass",
        "optionsArray",
        "onChangeProp",
        "selectedValue",
        "multiple"
    ]);
    var isValid = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Boolean);
    var sortedOptions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(optionsArray).sort(function(a, b) {
            var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
            if (nameA < nameB) {
                //sort string ascending
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }, [
        optionsArray
    ]);
    var handleChange = function(event, value, _reason) {
        onChangeProp(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        variant: "filled",
        fullWidth: true,
        className: containerClass,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Autocomplete__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            multiple: true,
            id: "multi-select",
            options: sortedOptions,
            getOptionLabel: function(option) {
                return option.name;
            },
            defaultValue: selectedValue,
            onChange: handleChange,
            renderInput: function(params) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                    variant: "filled"
                }, params, rest), {
                    error: !isValid || error,
                    helperText: !isValid && errorMessages || helperText
                }));
            }
        })
    });
};


/***/ }),

/***/ 50242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getManualProcessMinutesProduced; },
/* harmony export */   "R": function() { return /* binding */ getManualProcessSamples; }
/* harmony export */ });
var convertToTimeDate = function(stop) {
    return {
        from: stop.timeRange.from ? new Date(stop.timeRange.from) : null,
        to: stop.timeRange.to ? new Date(stop.timeRange.to) : null
    };
};
var getManualProcessMinutesProduced = function(from, to, stops) {
    var stopTimes = stops.map(convertToTimeDate);
    return getMinutesProduced(from, to, stopTimes);
};
var getMinutesProduced = function(from, to, stopTimes) {
    var duration = to.getTime() - from.getTime();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stopTimes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stop = _step.value;
            if ((!stop.to || stop.to > from) && (!stop.from || stop.from < to)) {
                var _to, _from;
                var overlapMs = Math.min(((_to = stop.to) !== null && _to !== void 0 ? _to : to).getTime(), to.getTime()) - Math.max(((_from = stop.from) !== null && _from !== void 0 ? _from : from).getTime(), from.getTime());
                duration -= overlapMs;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return duration / 1..minutes;
};
var getManualProcessSamples = function(from, to, stops, points) {
    var result = [];
    var stopTimes = stops.map(convertToTimeDate);
    var duration = to.getTime() - from.getTime();
    var interval = Math.floor(duration / points);
    interval = interval > 30..seconds ? interval : 30..seconds;
    for(var sampleStartMs = from.getTime(); sampleStartMs < to.getTime(); sampleStartMs += interval){
        var sampleStart = new Date(sampleStartMs);
        var sampleEnd = new Date(sampleStartMs + interval - 1);
        result.push(createSample(sampleStart, sampleEnd, getMinutesProduced(sampleStart, sampleEnd, stopTimes)));
    }
    return result;
};
var createSample = function(from, to, value) {
    return {
        timeRange: {
            from: from.toISOString(),
            to: to.toISOString()
        },
        data: {
            accValue: value,
            count: 1,
            minValue: value,
            maxValue: value
        }
    };
};


/***/ }),

/***/ 17547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ withIAM; },
/* harmony export */   "y": function() { return /* binding */ withIAMPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _BlackbirdHQ_ui_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(330);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6203);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53888);
/* harmony import */ var _mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(63557);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35192);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27908);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1827);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19328);
/* harmony import */ var _contexts_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9522);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(21586);
/* harmony import */ var _hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56386);
/* harmony import */ var _lib_features__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44377);





















// FIXME: Correct the user context signature...
// tslint:disable:max-classes-per-file
var withIAM = function(WrappedComponent) {
    return /*#__PURE__*/ function(_Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMWrapper, _Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMWrapper);
        function WithIAMWrapper() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMWrapper);
            return _super.apply(this, arguments);
        }
        var _proto = WithIAMWrapper.prototype;
        _proto.render = function render() {
            var _this = this;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                children: function(user) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        user: user,
                        features: user.features,
                        hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                        hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                        hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                        hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                        hasFeatureInAnyUserPool: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features),
                        hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                    }, _this.props));
                }
            });
        };
        return WithIAMWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
};
var styles = function(theme) {
    return {
        card: {
            width: "100%",
            maxWidth: "500px"
        },
        fillHeight: {
            height: "100%"
        },
        title: {
            marginBottom: theme.spacing(2)
        }
    };
};
var withIAMPage = function(lookupFeatures, featureType) {
    var scope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "group";
    return function(WrappedComponent) {
        var WithIAMPageWrapper = /*#__PURE__*/ function(_Component) {
            "use strict";
            (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(WithIAMPageWrapper, _Component);
            var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(WithIAMPageWrapper);
            function WithIAMPageWrapper() {
                (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, WithIAMPageWrapper);
                return _super.apply(this, arguments);
            }
            var _proto = WithIAMPageWrapper.prototype;
            _proto.render = function render() {
                var _props = this.props, classes = _props.classes, t = _props.t, i18n = _props.i18n, tReady = _props.tReady, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_props, [
                    "classes",
                    "t",
                    "i18n",
                    "tReady"
                ]);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_contexts_user__WEBPACK_IMPORTED_MODULE_7__/* .UserContext.Consumer */ .S.Consumer, {
                    children: function(_param) {
                        var status = _param.status, user = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
                            "status"
                        ]);
                        var allowed = scope === "userPool" ? _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyUserPool */ .xX(user.features)(lookupFeatures, featureType) : _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features)(lookupFeatures, featureType);
                        var wrappedMessage;
                        if (!status.loading && user && user.features && !allowed) {
                            wrappedMessage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                item: true,
                                xs: 12,
                                className: classes.fillHeight,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                    container: true,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    className: classes.fillHeight,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                            className: classes.card,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            variant: "h5",
                                                            className: classes.title,
                                                            children: t([
                                                                "shared:unfortunatelyNoPermission"
                                                            ], {
                                                                defaultValue: "Unfortunately, you don't have permission to view this page!"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                            children: t([
                                                                "shared:contactYourLocalAdminIfWrong"
                                                            ], {
                                                                defaultValue: "If you believe this is a mistake, contact your local administrator, and they can grant you access."
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardActions__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BlackbirdHQ_ui_base__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rU, {
                                                        href: {
                                                            pathname: "/"
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            color: "primary",
                                                            children: t([
                                                                "shared:returnToFrontPage"
                                                            ], {
                                                                defaultValue: "Return to front page"
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_loading_or_error__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                            loading: status.loading,
                            error: status.error,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                                features: user.features,
                                hasPeripheralFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "peripheral"),
                                hasGroupFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "group"),
                                hasLineFeatures: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .generateForItem */ .SN(user.features, "line"),
                                hasFeatureInAnyGroup: _lib_features__WEBPACK_IMPORTED_MODULE_9__/* .inAnyGroup */ .ne(user.features),
                                hasModuleAccess: (0,_hooks_use_iam__WEBPACK_IMPORTED_MODULE_10__/* .makeModuleAccessChecker */ .j)(user.claims)
                            }, restProps))
                        });
                    }
                });
            };
            return WithIAMPageWrapper;
        }(react__WEBPACK_IMPORTED_MODULE_2__.Component);
        var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_3__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_19__/* .withTranslation */ .Z)([
            "shared"
        ]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_20__/* .withStyles */ .D)(styles));
        return enhance(WithIAMPageWrapper);
    };
};


/***/ }),

/***/ 43146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ withUtils; },
/* harmony export */   "n": function() { return /* binding */ useUtils; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52481);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41586);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33392);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83265);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20330);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31503);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52682);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(32021);







var additionalUtils = function(locale) {
    return {
        formatDistance: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatDistanceStrict: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatRelative: function(date, baseDate) {
            var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(date, baseDate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, options), {
                locale: locale
            }));
        },
        formatWeekdays: function(formatString) {
            var now = new Date();
            return (0,date_fns__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                start: (0,date_fns__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                }),
                end: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, {
                    locale: locale,
                    weekStartsOn: 0
                })
            }).map(function(day) {
                return (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(day, formatString, {
                    locale: locale
                });
            });
        }
    };
};
var useUtils = function() {
    var utils = new _date_io_date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
    return Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")));
};
var withUtils = function(WrappedComponent) {
    return function(props) {
        var utils = useUtils();
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
            utils: Object.assign(utils, additionalUtils((utils === null || utils === void 0 ? void 0 : utils.locale) || (0,_locale__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("enUS")))
        }));
    };
};


/***/ }),

/***/ 143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ updateDataHash; },
/* harmony export */   "u": function() { return /* binding */ hashCode; }
/* harmony export */ });
var hashCode = function(s) {
    var hash = 0;
    if (!(s === null || s === void 0 ? void 0 : s.length)) {
        return String(hash);
    }
    for(var i = 0; i < s.length; i++){
        var char = s.charCodeAt(i);
        // eslint-disable-next-line no-bitwise
        hash = (hash << 5) - hash + char;
        // eslint-disable-next-line no-bitwise
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash);
};
var updateDataHash = function(setDataHash) {
    return function(data) {
        if (data) {
            var hash = hashCode(JSON.stringify(data));
            setDataHash(hash);
        }
    };
};


/***/ }),

/***/ 89414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48417);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89178);
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50663);
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_partition__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64191);
/* harmony import */ var _helpers_manual_process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50242);
/* harmony import */ var _lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95235);
// eslint-disable-next-line max-classes-per-file







var manualProcessConfig = function(param) {
    var data = param.data, selectedTime = param.selectedTime, refetch = param.refetch, pendingControls = param.pendingControls, selectedControlId = param.selectedControlId, chartHeight = param.chartHeight, theme = param.theme, disableLabels = param.disableLabels, onClickStop = param.onClickStop, onOverrideClick = param.onOverrideClick, setSelectedTime = param.setSelectedTime;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var from = ((ref = data.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.timeRange) === null || ref2 === void 0 ? void 0 : ref2.from) ? new Date((ref3 = data.time) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.timeRange) === null || ref5 === void 0 ? void 0 : ref5.from) : new Date();
    var to = ((ref6 = data.time) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.timeRange) === null || ref8 === void 0 ? void 0 : ref8.to) ? new Date((ref9 = data.time) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.timeRange) === null || ref11 === void 0 ? void 0 : ref11.to) : new Date();
    var ref18;
    var stops = (ref18 = (ref12 = data.time) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.stops) !== null && ref18 !== void 0 ? ref18 : [];
    var ref19;
    var batches = (ref19 = (ref14 = data.time) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.batches) !== null && ref19 !== void 0 ? ref19 : [];
    var ref20;
    var dataOverrides = (ref20 = (ref16 = data.time) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.dataOverrides) !== null && ref20 !== void 0 ? ref20 : [];
    var selectedTimeSeries = !selectedTime ? [] : [
        {
            animation: false,
            type: "scatter",
            showInLegend: false,
            enableMouseTracking: false,
            data: [
                {
                    x: selectedTime.getTime(),
                    y: 0,
                    color: "purple",
                    marker: {
                        radius: 6
                    }
                }, 
            ],
            states: {
                inactive: {
                    opacity: 1
                }
            }
        }, 
    ];
    return {
        title: false,
        exporting: {
            enabled: false
        },
        chart: {
            resetZoomButton: {
                theme: {
                    display: "none"
                }
            },
            zoomType: "x",
            height: chartHeight + "px",
            events: {
                click: function click(e) {
                    var ref, ref1;
                    if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.xAxis) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                        var ref2, ref3;
                        setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref2 = e.xAxis) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value));
                    }
                },
                selection: function selection(e) {
                    if (refetch) {
                        e.preventDefault();
                        refetch(new Date(e.xAxis[0].min), new Date(e.xAxis[0].max), true);
                    }
                }
            }
        },
        series: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getSerie(from, to, stops, dataOverrides, setSelectedTime)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPendingControlsSeries(pendingControls !== null && pendingControls !== void 0 ? pendingControls : [], selectedControlId !== null && selectedControlId !== void 0 ? selectedControlId : null)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(selectedTimeSeries)),
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: {
                month: "%e. %b",
                year: "%b"
            },
            plotBands: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getBatchAndStopsPlotBands */ .i0)(batches, [], {
                from: from,
                to: to
            }, theme)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getClickableStopPlotBands(stops, theme, onClickStop, disableLabels)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getOverridesPlotBands */ .fb)(dataOverrides, {
                from: from,
                to: to
            }, theme, onOverrideClick))),
            minTickInterval: 30..seconds
        },
        yAxis: {
            min: 0,
            max: 2,
            maxPadding: 0.05,
            endOnTick: false,
            labels: {
                enabled: false
            },
            title: {
                text: undefined
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: true
        },
        tooltip: {
            enabled: true,
            pointFormat: ""
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: false,
                        animation: false
                    }
                }
            },
            area: {
                marker: {
                    radius: 2,
                    enabled: false
                },
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null
            }
        }
    };
};
var getSerie = function(from, to, stops, dataOverrides, onClick) {
    var stopTimes = stops.length > 0 ? stops : dataOverrides.filter(function(override) {
        return override.value === 0;
    });
    var samples = (0,_helpers_manual_process__WEBPACK_IMPORTED_MODULE_3__/* .getManualProcessSamples */ .R)(from, to, stopTimes, _constants__WEBPACK_IMPORTED_MODULE_4__/* .SAMPLE_POINTS */ .fd);
    var color = (0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getSerieColor */ .RI)(generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__/* .SensorType.MANUAL_PROCESS */ .dE.MANUAL_PROCESS, 0);
    var data = samples.map(function(s) {
        return {
            x: new Date(s.timeRange.from).getTime(),
            y: s.data.accValue === 0 ? 0 : 1
        };
    });
    return [
        // serie 0, main data line / area graph
        {
            animation: false,
            type: "area",
            id: "obj.name",
            name: "",
            data: data,
            color: color.color,
            showInLegend: false,
            shared: false,
            zIndex: 5,
            events: {
                click: function click(e) {
                    var ref;
                    if (onClick && (e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x)) {
                        var ref1;
                        onClick(new Date(e === null || e === void 0 ? void 0 : (ref1 = e.point) === null || ref1 === void 0 ? void 0 : ref1.x));
                    }
                }
            }
        }, 
    ];
};
var getClickableStopPlotBands = function(stops, theme, onClick, disableLabels) {
    return stops.map(function(stop) {
        var causeType = stop.stopCause ? stop.stopCause.stopType : "UNREGISTERED_PLOT_BAND";
        return {
            from: stop.timeRange.from ? new Date(stop.timeRange.from).getTime() : null,
            to: stop.timeRange.to ? new Date(stop.timeRange.to).getTime() : null,
            color: theme.blackbird.stops[causeType].color.main,
            id: stop.timeRange.from,
            label: !disableLabels && {
                useHTML: true,
                text: stop.stopCause ? stop.stopCause.name : undefined,
                style: {
                    width: "100px",
                    textOverflow: "ellipsis"
                },
                rotation: 90,
                textAlign: "left",
                verticalAlign: "top"
            },
            zIndex: 6,
            events: {
                click: onClick ? function() {
                    return onClick(stop);
                } : undefined
            }
        };
    });
};
var getPendingControlsSeries = function(pendingControls, selectedControlId) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(lodash_partition__WEBPACK_IMPORTED_MODULE_0___default()(pendingControls, function(control) {
        return control.batchControlId === selectedControlId;
    }), 2), selectedControls = ref[0], unselectedControls = ref[1];
    return [
        {
            animation: false,
            type: "scatter",
            id: "unselected-pending-controls",
            name: "",
            showInLegend: false,
            data: unselectedControls.map(function(control) {
                return [
                    new Date(control.timeTriggered).getTime(),
                    0
                ];
            }),
            marker: {
                fillColor: "#FFC107",
                symbol: "triangle",
                radius: 5
            },
            zIndex: 10
        },
        {
            animation: false,
            type: "scatter",
            id: "selected-pending-controls",
            name: "",
            showInLegend: false,
            data: selectedControls.map(function(control) {
                return [
                    new Date(control.timeTriggered).getTime(),
                    0
                ];
            }),
            marker: {
                fillColor: "#ff8f00",
                radius: 8,
                symbol: "triangle"
            },
            zIndex: 10
        }, 
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (manualProcessConfig);


/***/ }),

/***/ 57191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ sensors; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(26806);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.6.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92869);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(54524);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(89178);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(85466);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.10_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(82197);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/withTranslation.js
var withTranslation = __webpack_require__(89928);
// EXTERNAL MODULE: ../../node_modules/.pnpm/recompose@0.30.0_react@17.0.2/node_modules/recompose/dist/Recompose.esm.js
var Recompose_esm = __webpack_require__(62690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.22.10_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(74571);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(19328);
// EXTERNAL MODULE: ./components/paginator.tsx
var paginator = __webpack_require__(82059);
// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(64191);
// EXTERNAL MODULE: ./graphql/queries/device-minimum-data.gql
var device_minimum_data = __webpack_require__(51844);
var device_minimum_data_default = /*#__PURE__*/__webpack_require__.n(device_minimum_data);
// EXTERNAL MODULE: ./graphql/queries/devices-simple.gql
var devices_simple = __webpack_require__(50936);
var devices_simple_default = /*#__PURE__*/__webpack_require__.n(devices_simple);
// EXTERNAL MODULE: ./hocs/with-styles.tsx
var with_styles = __webpack_require__(21586);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(46242);
// EXTERNAL MODULE: ./lib/hash.ts
var hash = __webpack_require__(143);
// EXTERNAL MODULE: ./types/helper-types.ts
var helper_types = __webpack_require__(97887);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@BlackbirdHQ+ui-base@0.1.0_@emotion+react@11.11.1_@emotion+styled@11.11.0_@mui+icons-material_kyohckkzppuivf3qidsibfbiei/node_modules/@BlackbirdHQ/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(36090);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(99443);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.13.5_@types+react@17.0.62_react@17.0.2/node_modules/@mui/icons-material/SettingsSharp.js
var SettingsSharp = __webpack_require__(41067);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(53888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(35192);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(74112);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(49692);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(88838);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(65897);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(98242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(55537);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
// EXTERNAL MODULE: ./components/containers/highcharts.tsx
var highcharts = __webpack_require__(92042);
// EXTERNAL MODULE: ./components/icons/node-icon.tsx
var node_icon = __webpack_require__(81009);
// EXTERNAL MODULE: ./components/icons/signal-avatar.tsx
var signal_avatar = __webpack_require__(72958);
// EXTERNAL MODULE: ./lib/highcharts/data-config.ts + 2 modules
var data_config = __webpack_require__(99512);
// EXTERNAL MODULE: ./lib/highcharts/manual-process-config.ts
var manual_process_config = __webpack_require__(89414);
// EXTERNAL MODULE: ./views/dialogs/sensor-settings/sensor-settings-dialog.tsx + 14 modules
var sensor_settings_dialog = __webpack_require__(30893);
;// CONCATENATED MODULE: ./views/sensors/device-overview-card.tsx

























var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        card: {
            minHeight: "100%",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing(),
            display: "flex",
            justifyContent: "space-around"
        },
        button: {
            margin: theme.spacing()
        },
        nodeIcon: {
            height: 25,
            width: 25,
            marginRight: theme.spacing(),
            marginBottom: theme.spacing(-1)
        },
        menu: {},
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
});
var DeviceOverviewCard = function(param) {
    var device = param.device, sensor = param.sensor, loading = param.loading, refetchQueries = param.refetchQueries, dataHash = param.dataHash;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)([
        "shared",
        "device"
    ]), 2), t = ref8[0], i18n = ref8[1];
    var classes = useStyles().classes;
    var theme = (0,useTheme/* default */.Z)();
    var ref9 = (0,react.useState)(false), settingsDialogOpen = ref9[0], setSettingsDialogOpen = ref9[1];
    var ref10 = (0,react.useState)(null), menuAnchorEl = ref10[0], setMenuAnchorEl = ref10[1];
    var openMenu = Boolean(menuAnchorEl);
    var uuid = device.uuid;
    var index = sensor.index, name = sensor.name, description = sensor.description, config = sensor.config;
    var ref11;
    var nodeType = (ref11 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.peripheralInformation) === null || ref === void 0 ? void 0 : (ref1 = ref.node) === null || ref1 === void 0 ? void 0 : ref1.type) !== null && ref11 !== void 0 ? ref11 : undefined;
    var ref12;
    var online = ((ref12 = sensor === null || sensor === void 0 ? void 0 : (ref2 = sensor.time) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.stats) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.lineStatus) === null || ref6 === void 0 ? void 0 : ref6.status) !== null && ref12 !== void 0 ? ref12 : schema/* Status.OFF */.qb.OFF) !== schema/* Status.OFF */.qb.OFF;
    var buttons = [
        {
            label: t([
                "shared:registerStops"
            ], {
                defaultValue: "Register Stops"
            }),
            uri: "register-stops"
        },
        {
            label: t([
                "shared:analytics"
            ], {
                defaultValue: "Analytics"
            }),
            uri: "analytics"
        }, 
    ];
    var isEnergyMeter = sensor.config.energyMeter === true;
    var openSettings = function(e) {
        setMenuAnchorEl(null);
        setSettingsDialogOpen(true);
        e.stopPropagation();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 6,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                className: classes.card,
                elevation: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_link/* ImperceptibleLink */.ah, {
                    href: {
                        pathname: "/sensor",
                        query: {
                            peripheralId: "".concat(uuid, "-").concat(index),
                            tab: "live"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "rtl-direction",
                            style: {
                                display: "flex",
                                padding: "16px 24px 16px 24px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body1",
                                            children: [
                                                nodeType ? (0,node_icon/* getNodeIcon */.nv)(classes.nodeIcon, nodeType) : null,
                                                name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            color: "textSecondary",
                                            variant: "body2",
                                            children: description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        flex: "0 0 auto",
                                        marginLeft: "15px",
                                        width: "40px",
                                        height: "40px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signal_avatar/* default */.Z, {
                                        online: online,
                                        uuid: uuid
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        flex: "0 0 auto",
                                        marginLeft: "5px",
                                        width: "40px",
                                        height: "40px"
                                    },
                                    children: [
                                        isEnergyMeter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            className: classes.menu,
                                            "aria-label": "Settings",
                                            onClick: openSettings,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            className: classes.menu,
                                            "aria-label": "More",
                                            "aria-owns": openMenu ? "long-menu" : undefined,
                                            "aria-haspopup": "true",
                                            onClick: function(e) {
                                                setMenuAnchorEl(e.currentTarget);
                                                e.stopPropagation();
                                                e.preventDefault();
                                            },
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* default */.Z, {
                                            id: "long-menu",
                                            anchorEl: menuAnchorEl,
                                            open: openMenu,
                                            onClose: function(e) {
                                                setMenuAnchorEl(null);
                                                // These functions exist even if TS doesn't think so
                                                e.stopPropagation();
                                                e.preventDefault();
                                            },
                                            PaperProps: {
                                                style: {}
                                            },
                                            children: [
                                                config && config.type === "MEASUREMENT" ? null : buttons.map(function(btn) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                                                        href: {
                                                            pathname: "/sensor",
                                                            query: {
                                                                peripheralId: "".concat(uuid, "-").concat(index),
                                                                tab: btn.uri
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                            selected: false,
                                                            children: btn.label
                                                        }, btn.uri)
                                                    }, btn.uri);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                                    variant: "middle"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                    selected: false,
                                                    onClick: openSettings,
                                                    className: classes.menuItemStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                            className: classes.menuItemIcon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "inherit",
                                                            noWrap: true,
                                                            children: t([
                                                                "sensor:sensorSettings"
                                                            ], {
                                                                defaultValue: "Sensor settings"
                                                            })
                                                        })
                                                    ]
                                                }, "sensorSettings")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                            className: "hideInPercy",
                            style: {
                                paddingBottom: 0
                            },
                            children: (sensor === null || sensor === void 0 ? void 0 : (ref7 = sensor.config) === null || ref7 === void 0 ? void 0 : ref7.type) !== schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                compareForUpdate: dataHash,
                                configOptions: {
                                    theme: theme,
                                    t: t,
                                    language: i18n.language,
                                    height: "180px",
                                    sensors: [
                                        sensor
                                    ],
                                    disableTooltip: true,
                                    disableExportMenu: true,
                                    showLegend: false
                                },
                                configFn: data_config/* default */.ZP,
                                loading: loading
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(highcharts/* Graph */.k, {
                                compareForUpdate: dataHash,
                                configOptions: {
                                    theme: theme,
                                    chartHeight: "180px",
                                    data: sensor,
                                    showLegend: false
                                },
                                configFn: manual_process_config/* default */.Z,
                                loading: loading
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_settings_dialog/* default */.Z, {
                handleDialogChange: function() {
                    setMenuAnchorEl(null);
                    setSettingsDialogOpen(false);
                },
                dialogOpen: settingsDialogOpen,
                peripheralId: sensor.peripheralId,
                refetchQueries: refetchQueries
            })
        ]
    });
};
/* harmony default export */ var device_overview_card = (DeviceOverviewCard);

// EXTERNAL MODULE: ./components/bars/overview-top-bar.tsx + 1 modules
var overview_top_bar = __webpack_require__(71981);
;// CONCATENATED MODULE: ./views/sensors/overview-top-bar.tsx






var DevicesTopBar = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DevicesTopBar, _Component);
    var _super = (0,_create_super/* default */.Z)(DevicesTopBar);
    function DevicesTopBar() {
        (0,_class_call_check/* default */.Z)(this, DevicesTopBar);
        var _this;
        _this = _super.apply(this, arguments);
        _this.generateSuggestions = function() {
            var filteredPeripherals = _this.props.filteredPeripherals;
            // Store all the suggestions in a map, to avoid duplicates.
            var suggestions = {};
            filteredPeripherals.forEach(function(peripheral) {
                // If we haven't started searching yet, include all results.
                if (!_this.props.search.length) {
                    var name = peripheral.name.toLowerCase();
                    if (name) {
                        suggestions[name] = {
                            label: peripheral.name,
                            value: {
                                type: "string",
                                value: name
                            }
                        };
                    }
                    var description = peripheral.description.toLowerCase();
                    if (description) {
                        suggestions[description] = {
                            label: peripheral.description,
                            value: {
                                type: "string",
                                value: description
                            }
                        };
                    }
                    var peripheralId = peripheral.peripheralId;
                    if (peripheralId) {
                        var lowerCasedPeripheralId = peripheralId.toLowerCase();
                        suggestions[lowerCasedPeripheralId] = {
                            label: peripheralId,
                            value: {
                                type: "string",
                                value: lowerCasedPeripheralId
                            }
                        };
                    }
                } else {
                    // Filter out both results and remaining suggestions, based on the search filter.
                    var foundInSearch = false;
                    _this.props.search.map(function(searchTerm) {
                        if (searchTerm && searchTerm.value && searchTerm.value.value) {
                            var name = peripheral.name.toLowerCase();
                            var description = peripheral.description.toLowerCase();
                            var peripheralId = peripheral.peripheralId;
                            var searchTermValue = searchTerm.value.value.toLowerCase();
                            foundInSearch = name.includes(searchTermValue) || description.includes(searchTermValue) || (peripheralId === null || peripheralId === void 0 ? void 0 : peripheralId.includes(searchTermValue));
                            if (foundInSearch) {
                                suggestions[name] = {
                                    label: peripheral.name,
                                    value: {
                                        type: "string",
                                        value: name
                                    }
                                };
                                suggestions[description] = {
                                    label: peripheral.description,
                                    value: {
                                        type: "string",
                                        value: description
                                    }
                                };
                                if (peripheralId) {
                                    var lowerCasedPeripheralId = peripheralId.toLowerCase();
                                    suggestions[lowerCasedPeripheralId] = {
                                        label: peripheralId,
                                        value: {
                                            type: "string",
                                            value: lowerCasedPeripheralId
                                        }
                                    };
                                }
                            }
                        }
                    });
                }
            });
            // Convert the map to an array of SearchValue.
            return Object.keys(suggestions).map(function(k) {
                return suggestions[k];
            });
        };
        return _this;
    }
    var _proto = DevicesTopBar.prototype;
    _proto.render = function render() {
        var _props = this.props, search = _props.search, page = _props.page, pageSize = _props.pageSize, filteredPeripherals = _props.filteredPeripherals, handlePageChange = _props.handlePageChange, handleSearchChange = _props.handleSearchChange;
        var suggestions = this.generateSuggestions();
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_top_bar/* default */.Z, {
            search: search,
            suggestions: suggestions,
            page: page,
            pageSize: pageSize,
            handlePageChange: handlePageChange,
            handleSearchChange: handleSearchChange,
            totalCount: filteredPeripherals.length
        });
    };
    return DevicesTopBar;
}(react.Component);
/* harmony default export */ var sensors_overview_top_bar = (DevicesTopBar);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react-player@2.12.0_react@17.0.2/node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(88345);
;// CONCATENATED MODULE: ./views/sensors/sensor-card-video.tsx





















var styles = function(theme) {
    return {
        card: {
            minHeight: "100%",
            transition: "box-shadow .25s",
            "&:hover": {
                boxShadow: "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)"
            }
        },
        actions: {
            paddingLeft: theme.spacing(),
            paddingBottom: theme.spacing(),
            display: "flex",
            justifyContent: "space-around"
        },
        button: {
            margin: theme.spacing()
        },
        nodeIcon: {
            height: 25,
            width: 25,
            marginRight: theme.spacing(),
            marginBottom: -theme.spacing()
        },
        menu: {},
        menuItemStyles: {
            padding: theme.spacing(),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        menuItemIcon: {
            minWidth: theme.spacing(4)
        }
    };
};
var DeviceOverviewVideoCard = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeviceOverviewVideoCard, _Component);
    var _super = (0,_create_super/* default */.Z)(DeviceOverviewVideoCard);
    function DeviceOverviewVideoCard() {
        (0,_class_call_check/* default */.Z)(this, DeviceOverviewVideoCard);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            isHover: false,
            settingsDialogOpen: false,
            menuAnchorEl: null
        };
        _this.handleDialogChange = function(open) {
            _this.setState({
                settingsDialogOpen: open
            });
        };
        _this.handleMenuClose = function() {
            _this.setState({
                menuAnchorEl: null
            });
        };
        _this.preventContextMenu = function(e) {
            return e.preventDefault();
        };
        _this.handleMenuClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                menuAnchorEl: e.currentTarget
            });
        };
        _this.closeMenu = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.handleMenuClose();
        };
        _this.openSettingsDialog = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.setState({
                menuAnchorEl: null,
                settingsDialogOpen: true
            });
        };
        return _this;
    }
    var _proto = DeviceOverviewVideoCard.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, device = _props.device, camera = _props.camera, t = _props.t;
        var _state = this.state, settingsDialogOpen = _state.settingsDialogOpen, menuAnchorEl = _state.menuAnchorEl;
        var openMenu = Boolean(menuAnchorEl);
        var uuid = device.uuid;
        var index = camera.index, name = camera.name, description = camera.description;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    className: classes.card,
                    elevation: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_link/* ImperceptibleLink */.ah, {
                        href: {
                            pathname: "/sensor",
                            query: {
                                peripheralId: "".concat(uuid, "-").concat(index),
                                tab: "camera"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    padding: "16px 24px 16px 24px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            flex: "1 1 auto"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body1",
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "textSecondary",
                                                variant: "body2",
                                                children: description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        style: {
                                            flex: "0 0 auto",
                                            marginLeft: "5px",
                                            width: "40px",
                                            height: "40px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                className: classes.menu,
                                                "aria-label": "More",
                                                "aria-owns": openMenu ? "long-menu" : undefined,
                                                "aria-haspopup": "true",
                                                onClick: this.handleMenuClick,
                                                size: "large",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                                                id: "long-menu",
                                                anchorEl: menuAnchorEl,
                                                open: openMenu,
                                                onClose: this.closeMenu,
                                                PaperProps: {
                                                    style: {}
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                    selected: false,
                                                    onClick: this.openSettingsDialog,
                                                    className: classes.menuItemStyles,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                            className: classes.menuItemIcon,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsSharp/* default */.Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "inherit",
                                                            noWrap: true,
                                                            children: t([
                                                                "sensor:sensorSettings"
                                                            ], {
                                                                defaultValue: "Sensor settings"
                                                            })
                                                        })
                                                    ]
                                                }, "sensorSettings")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                style: {
                                    padding: "0px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        height: "215px",
                                        overflow: "hidden",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: camera.streamURL !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(lazy/* default */.Z, {
                                        url: camera.streamURL,
                                        width: "100%",
                                        height: "auto",
                                        controls: false,
                                        onContextMenu: this.preventContextMenu,
                                        config: {
                                            file: {
                                                hlsOptions: {
                                                    autoStartLoad: true,
                                                    maxMaxBufferLength: 0.1
                                                }
                                            }
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        display: "block",
                                        children: t([
                                            "device:cameraIsOffline"
                                        ], {
                                            defaultValue: "Camera appears to be offline"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_settings_dialog/* default */.Z, {
                    handleDialogChange: this.handleDialogChange,
                    dialogOpen: settingsDialogOpen,
                    peripheralId: camera.peripheralId
                })
            ]
        });
    };
    return DeviceOverviewVideoCard;
}(react.Component);
var enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]), (0,with_styles/* withStyles */.D)(styles, {
    withTheme: true
}));
/* harmony default export */ var sensor_card_video = (enhance(DeviceOverviewVideoCard));

;// CONCATENATED MODULE: ./views/sensors/overview-page.tsx
































// We extract the query, so that we can maintain a state for each Apollo query.
var InternalDeviceCard = function(param) {
    var peripheral = param.peripheral, deviceVariables = param.deviceVariables;
    var ref = (0,react.useState)(""), dataHash = ref[0], setDataHash = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
        ssr: false,
        partialRefetch: true,
        context: {
            batchFour: true
        },
        errorPolicy: "all" // Necessary for returning partial data.
        ,
        query: (device_minimum_data_default()),
        fetchPolicy: "cache-and-network",
        onCompleted: (0,hash/* updateDataHash */.G)(setDataHash),
        variables: deviceVariables,
        children: function(param) {
            var data = param.data, loading = param.loading;
            var ref;
            var ref1;
            var sensor = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.device) === null || ref === void 0 ? void 0 : ref.peripheral) !== null && ref1 !== void 0 ? ref1 : peripheral;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(device_overview_card, {
                device: peripheral.parentDevice,
                dataHash: dataHash,
                sensor: sensor,
                loading: loading,
                refetchQueries: [
                    {
                        query: (device_minimum_data_default()),
                        variables: deviceVariables
                    }, 
                ]
            }, "".concat(peripheral.parentDevice.uuid).concat(sensor.index));
        }
    }, "".concat(peripheral.parentDevice.uuid).concat(peripheral.index));
};
var PeripheralCards = function(param) {
    var filteredPeripherals = param.filteredPeripherals, currentPage = param.currentPage, pageSize = param.pageSize, timeAtLoad = param.timeAtLoad;
    var mostRecentMinute = Math.round(timeAtLoad.getTime() / (1000 * 60)) * 1000 * 60;
    var currentPagePeripherals = (0,_to_consumable_array/* default */.Z)(filteredPeripherals).slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    /* Note:
   *  The below piece of code deliberately launches a request per sensor card in view.
   *  This is done in order to better utilize the client side cache from already loaded devices,
   *  while filtering and changing page. Another pro of doing it as potentially 6 requests,
   *  is that the loading of the cards are asynchronous, which gives a great user experience.
   *  The alternative was to make a single request for all 6 devices, loosing the above pros.
   */ return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: currentPagePeripherals.map(function(peripheral) {
            if (peripheral.peripheralType === schema/* PeripheralType.SENSOR */.Ti.SENSOR) {
                var deviceVariables = {
                    uuid: peripheral.parentDevice.uuid,
                    index: peripheral.index,
                    time: [
                        {
                            from: new Date(mostRecentMinute - 8..hours).toISOString(),
                            to: new Date(mostRecentMinute).toISOString()
                        }, 
                    ],
                    points: constants/* SAMPLE_POINTS */.fd
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalDeviceCard, {
                    peripheral: peripheral,
                    deviceVariables: deviceVariables
                }, peripheral._id || Math.random());
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(sensor_card_video, {
                    device: peripheral.parentDevice,
                    camera: peripheral
                }, "".concat(peripheral.parentDevice.uuid).concat(peripheral.index));
            }
        })
    });
};
var overview_page_styles = function(theme) {
    return {
        fillHeight: {
            height: "100%"
        },
        flexContainer: {
            display: "flex"
        }
    };
};
var DeviceCardPage = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DeviceCardPage, _Component);
    var _super = (0,_create_super/* default */.Z)(DeviceCardPage);
    function DeviceCardPage(props) {
        (0,_class_call_check/* default */.Z)(this, DeviceCardPage);
        var _this;
        var ref, ref1;
        _this = _super.call(this, props);
        _this.state = {
            search: [],
            page: 0,
            compareDevices: [],
            flattenedPeripherals: []
        };
        _this.pageSize = constants/* PAGE_SIZE */.IV;
        _this.filterPeripherals = function(devices) {
            var flattenedPeripherals = _this.state.flattenedPeripherals;
            // This covers hot reloading, which won't call onCompleted again, and clears state.
            if (!flattenedPeripherals || flattenedPeripherals.length === 0) {
                flattenedPeripherals = devices.reduce(function(prev, cur) {
                    var _prev;
                    (_prev = prev).push.apply(_prev, (0,_to_consumable_array/* default */.Z)(((cur === null || cur === void 0 ? void 0 : cur.peripherals) || []).filter(helper_types/* isTruthy */.f).map(function(peripheral) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                            parentDevice: cur
                        });
                    })));
                    return prev;
                }, []);
            }
            var filteredPeripherals = flattenedPeripherals.filter(function(peripheral) {
                // If we haven't started searching yet, include all results.
                if (!_this.state.search.length) {
                    return true;
                }
                // Filter out both results and remaining suggestions, based on the search filter.
                var foundInSearch = false;
                _this.state.search.map(function(searchTerm) {
                    if (searchTerm && searchTerm.value && searchTerm.value.value) {
                        var ref;
                        foundInSearch = peripheral.name.toLowerCase().includes(searchTerm.value.value.toLowerCase()) || peripheral.description.toLowerCase().includes(searchTerm.value.value.toLowerCase()) || ((ref = peripheral.peripheralId) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(searchTerm.value.value.toLowerCase()));
                    }
                });
                return foundInSearch;
            });
            // Sort the devices alphabetically, to always give a consistent view to the user.
            return filteredPeripherals.sort(function(left, right) {
                return left.name.localeCompare(right.name);
            }).sort(function(peripheral) {
                return +(peripheral.peripheralType === schema/* PeripheralType.CAMERA */.Ti.CAMERA);
            });
        };
        _this.getWrappedMessage = function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: _this.props.t([
                            "shared:accessToNoDevices"
                        ], {
                            defaultValue: "You do not have access to any sensors yet!"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        children: _this.props.t([
                            "shared:contactLocalAdministrator"
                        ], {
                            defaultValue: "Please contact your local administrator for help."
                        })
                    })
                ]
            });
        };
        _this.finishedQueringDevice = function(data) {
            var ref;
            var devices = ((ref = data === null || data === void 0 ? void 0 : data.devices) !== null && ref !== void 0 ? ref : []).filter(helper_types/* isTruthy */.f);
            var flattenedPeripherals = _this.state.flattenedPeripherals;
            // Flatten the devices only when we get new data.
            if (devices.length !== 0 && (!(flattenedPeripherals === null || flattenedPeripherals === void 0 ? void 0 : flattenedPeripherals.length) || !isEqual_default()(devices, _this.state.compareDevices))) {
                var updatedFlattenedPeripherals = devices.filter(function(device) {
                    return device;
                }).reduce(function(prev, cur) {
                    var _prev;
                    (_prev = prev).push.apply(_prev, (0,_to_consumable_array/* default */.Z)((cur.peripherals || []).filter(helper_types/* isTruthy */.f).map(function(peripheral) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, peripheral), {
                            parentDevice: cur
                        });
                    })));
                    return prev;
                }, []);
                _this.setState({
                    flattenedPeripherals: updatedFlattenedPeripherals,
                    compareDevices: devices
                });
            }
        };
        _this.updateSessionStorage = function(newRoute) {
            // Update the session (tab specific) storage entry for navigation.
            if (typeof Storage !== "undefined") {
                window.sessionStorage.setItem(constants/* SESSION_STORAGE_DEVICES_NAVIGATION_OVERVIEW_SEARCH_STATE_KEY */.Vi, JSON.stringify({
                    route: {
                        pathname: newRoute.pathname,
                        query: newRoute.query
                    }
                }));
            }
        };
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handlePageChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this1.props.router, pathname = _router.pathname, query = _router.query;
                            _this1.setState({
                                page: page
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                page: page
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this1.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }();
        var _this2 = (0,_assert_this_initialized/* default */.Z)(_this);
        _this.handleSearchChange = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(val) {
                var _router, pathname, query, updatedQuery, url;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _router = _this2.props.router, pathname = _router.pathname, query = _router.query;
                            _this2.setState({
                                search: val,
                                page: 0
                            });
                            updatedQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                                search: JSON.stringify(val),
                                page: 0
                            });
                            url = (0,native_url.format)({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            _this2.updateSessionStorage({
                                pathname: pathname,
                                query: updatedQuery
                            });
                            return [
                                4,
                                router_default().replace(url, url, {
                                    shallow: true
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }();
        if (props.router.query.search) {
            try {
                var searchQuery = Array.isArray(props.router.query.search) ? props.router.query.search[0] : props.router.query.search;
                _this.state.search = JSON.parse(searchQuery);
            } catch (routerError) {
                console.error(routerError);
            }
        }
        if (props.router.query.page) {
            try {
                var pageQuery = Array.isArray(props.router.query.page) ? props.router.query.page[0] : props.router.query.page;
                _this.state.page = parseInt(pageQuery, 10);
            } catch (routerError1) {
                console.error(routerError1);
            }
        }
        var ref2, ref3;
        _this.updateSessionStorage({
            pathname: (ref2 = props === null || props === void 0 ? void 0 : (ref = props.router) === null || ref === void 0 ? void 0 : ref.pathname) !== null && ref2 !== void 0 ? ref2 : "/sensors",
            query: (ref3 = props === null || props === void 0 ? void 0 : (ref1 = props.router) === null || ref1 === void 0 ? void 0 : ref1.query) !== null && ref3 !== void 0 ? ref3 : {}
        });
        return _this;
    }
    var _proto = DeviceCardPage.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, width = _props.width, timeAtLoad = _props.timeAtLoad;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Query/* Query */.A, {
            query: (devices_simple_default()),
            partialRefetch: true,
            onCompleted: this.finishedQueringDevice,
            ssr: false,
            fetchPolicy: "cache-and-network",
            errorPolicy: "all" // Necessary for returning partial data.
            ,
            children: function(param) {
                var loading = param.loading, error = param.error, data = param.data;
                var ref;
                var devices = (ref = data === null || data === void 0 ? void 0 : data.devices) !== null && ref !== void 0 ? ref : [];
                var wrappedMessage = !loading && !error && !devices.length ? _this.getWrappedMessage() : undefined;
                // We only short-circuit the render if the query is loading or returned only an error (i.e. not an error + data).
                if (loading && !data || error && !data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sensors_overview_top_bar, {
                                search: _this.state.search,
                                page: _this.state.page,
                                pageSize: _this.pageSize,
                                filteredPeripherals: [],
                                handlePageChange: _this.handlePageChange,
                                handleSearchChange: _this.handleSearchChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                                loading: loading,
                                error: error,
                                wrappedMessage: wrappedMessage
                            })
                        ]
                    });
                }
                var filteredPeripherals = _this.filterPeripherals(devices.filter(helper_types/* isTruthy */.f));
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sensors_overview_top_bar, {
                            search: _this.state.search,
                            page: _this.state.page,
                            pageSize: _this.pageSize,
                            filteredPeripherals: filteredPeripherals,
                            handlePageChange: _this.handlePageChange,
                            handleSearchChange: _this.handleSearchChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
                            loading: loading,
                            error: error,
                            data: data,
                            wrappedMessage: wrappedMessage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                container: true,
                                spacing: 1,
                                alignItems: "stretch",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PeripheralCards, {
                                        filteredPeripherals: filteredPeripherals,
                                        currentPage: _this.state.page,
                                        pageSize: _this.pageSize,
                                        timeAtLoad: timeAtLoad
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                        mdUp: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paginator/* default */.Z, {
                                                totalPages: Math.ceil(filteredPeripherals.length / _this.pageSize),
                                                currentPage: _this.state.page,
                                                onCurrentPageChange: _this.handlePageChange,
                                                totalCount: filteredPeripherals.length,
                                                pageSize: _this.pageSize
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        });
    };
    return DeviceCardPage;
}(react.Component);
var overview_page_enhance = (0,Recompose_esm/* compose */.qC)((0,withTranslation/* withTranslation */.Z)([
    "shared",
    "device"
]), router.withRouter, (0,with_styles/* withStyles */.D)(overview_page_styles), (0,with_width/* withWidth */.of)());
/* harmony default export */ var overview_page = (overview_page_enhance(DeviceCardPage));

;// CONCATENATED MODULE: ./pages/sensors/index.tsx



var Sensors = function() {
    var ref = (0,react.useState)(Date.now()), fetchTime = ref[0], setFetchTime = ref[1];
    (0,react.useEffect)(function() {
        var handle = setTimeout(function() {
            setFetchTime(Date.now());
        }, 5..minutes);
        return function() {
            return clearTimeout(handle);
        };
    }, [
        fetchTime
    ]);
    var timeAtLoad = (0,react.useMemo)(function() {
        return new Date(fetchTime);
    }, [
        fetchTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(overview_page, {
        timeAtLoad: timeAtLoad
    });
};
var __N_SSG = true;
/* harmony default export */ var sensors = (Sensors);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7318,2742,6355,6197,4074,3281,1791,1024,4511,4354,5280,7179,3798,3280,5833,3417,8778,403,3094,7788,1843,9330,8345,9917,9334,4518,9774,2888,179], function() { return __webpack_exec__(40636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);